const userRoles = {
  administrator: 'Administrator',
  superUser: 'Super User',
  basicUser: 'Basic User',
};

export { userRoles };
